module.exports = {
  0: "Pending",
  1: "Verified",
  2: "Deleted",
};
